import { IRemoteRefreshSchedule } from '../types/IRemoteRefreshSchedule';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IDeleteRemoteRefreshSchedulesParams {
  targetId: string;
  schedules: IRemoteRefreshSchedule[];
}

export class DeleteRemoteRefreshSchedulesRequest extends Request<IDeleteRemoteRefreshSchedulesParams, IResult> {
  constructor(params: IDeleteRemoteRefreshSchedulesParams) {
    super('deleteRemoteRefreshSchedules', params);
  }
}
